import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const create_support_ticket = createAsyncThunk(
    'support/create',
    async (payload, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.post('/home/support/tickets', payload)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const get_my_support_tickets = createAsyncThunk(
    'support/list',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get('/home/support/tickets')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const get_support_ticket = createAsyncThunk(
    'support/detail',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/support/tickets/${id}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const add_support_message = createAsyncThunk(
    'support/reply',
    async ({ id, message }, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.post(`/home/support/tickets/${id}/messages`, { message })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

export const close_support_ticket = createAsyncThunk(
    'support/close',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await api.patch(`/home/support/tickets/${id}/close`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Xəta baş verdi' })
        }
    }
)

const supportSlice = createSlice({
    name: 'support',
    initialState: {
        tickets: [],
        ticket: null,
        loader: false,
        submitLoader: false,
        successMessage: '',
        errorMessage: '',
        createdId: null,
    },
    reducers: {
        messageClear: (state) => { state.successMessage = ''; state.errorMessage = ''; state.createdId = null },
        clearTicket: (state) => { state.ticket = null },
    },
    extraReducers: (builder) => {
        builder
            .addCase(create_support_ticket.pending, (state) => { state.submitLoader = true })
            .addCase(create_support_ticket.fulfilled, (state, { payload }) => {
                state.submitLoader = false
                state.successMessage = payload.message
                state.createdId = payload.ticket?._id || null
            })
            .addCase(create_support_ticket.rejected, (state, { payload }) => {
                state.submitLoader = false
                state.errorMessage = payload?.error || 'Xəta baş verdi'
            })

            .addCase(get_my_support_tickets.pending, (state) => { state.loader = true })
            .addCase(get_my_support_tickets.fulfilled, (state, { payload }) => { state.loader = false; state.tickets = payload.tickets || [] })
            .addCase(get_my_support_tickets.rejected, (state) => { state.loader = false })

            .addCase(get_support_ticket.pending, (state) => { state.loader = true })
            .addCase(get_support_ticket.fulfilled, (state, { payload }) => { state.loader = false; state.ticket = payload.ticket || null })
            .addCase(get_support_ticket.rejected, (state, { payload }) => { state.loader = false; state.errorMessage = payload?.error || 'Tapılmadı' })

            .addCase(add_support_message.fulfilled, (state, { payload }) => { state.ticket = payload.ticket || state.ticket; state.successMessage = payload.message })
            .addCase(add_support_message.rejected, (state, { payload }) => { state.errorMessage = payload?.error || 'Göndərilmədi' })

            .addCase(close_support_ticket.fulfilled, (state, { payload }) => { state.ticket = payload.ticket || state.ticket; state.successMessage = payload.message })
            .addCase(close_support_ticket.rejected, (state, { payload }) => { state.errorMessage = payload?.error || 'Bağlanmadı' })
    }
})

export const { messageClear, clearTicket } = supportSlice.actions
export default supportSlice.reducer

// Paylaşılan etiketlər
export const SUPPORT_CATEGORIES = [
    { value: 'order_problem',         label: 'Sifariş problemi' },
    { value: 'product_not_delivered', label: 'Məhsul təhvil verilmədi' },
    { value: 'product_not_working',   label: 'Məhsul işləmir' },
    { value: 'payment_balance',       label: 'Ödəniş / balans' },
    { value: 'seller_complaint',      label: 'Satıcıdan şikayət' },
    { value: 'account_login',         label: 'Hesab / giriş' },
    { value: 'seller_application',    label: 'Satıcı olmaq' },
    { value: 'official_product',      label: 'Rəsmi məhsul sifarişi' },
    { value: 'other',                 label: 'Digər' },
]
export const SUPPORT_CATEGORY_LABEL = SUPPORT_CATEGORIES.reduce((a, c) => ({ ...a, [c.value]: c.label }), {})
export const SUPPORT_STATUS = {
    open:             { label: 'Açıq',                 cls: 'bg-brand-100 text-brand-700' },
    waiting_support:  { label: 'Dəstək gözləyir',      cls: 'bg-amber-100 text-amber-700' },
    waiting_customer: { label: 'Cavabınız gözlənilir', cls: 'bg-sky-100 text-sky-700' },
    resolved:         { label: 'Həll olundu',          cls: 'bg-success-100 text-success-700' },
    closed:           { label: 'Bağlandı',             cls: 'bg-slate-200 text-slate-600' },
}
